import React, {useEffect, useState} from "react";
import {wdiCore, WdiInput, WdiModalAppProps} from "@/components/WdiControls";
import {Col, Form, message, Row} from "antd";
import {InvoiceMaker} from "@/services/mdm/invoicemaker";
import {Supplier} from "@/services/mdm/supplier";
import DataStore from "@/components/GridWidget/DataStore";
import {ColumnsType} from "antd/lib/table";
import {Enum} from "@/enums/system";
import {Invoices} from "@/services/sales/financial/invoices";
import {ResponseStatus} from "@/utils/request";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {WdiSelect, WdiSelectFormat} from "@/components/WdiControls/WdiSelect";

export const InvoiceCreateApp: React.FC<WdiModalAppProps> = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);

  const {data} = props;
  useEffect(() => {
    const invoiceDetails: any[] = [];
    data?.invoices.map((invoice: any) => {
      invoice?.details.map((detail: any) => {
        invoiceDetails.push(Object.assign({...invoice}, {...detail}));
      })
    })
    setDataSource(DataStore.init(invoiceDetails))
  }, [data])

  const columns: ColumnsType<any> = [
    {
      title: '发票号码',
      width: 150,
      dataIndex: 'invoiceNo',
      ellipsis: true,
    },
    {
      title: '发票代码',
      width: 150,
      dataIndex: 'invoiceCode',
      ellipsis: true,
    },
    {
      title: '货物/服务名称',
      dataIndex: 'commodityName',
      ellipsis: true,
    },
    {
      title: '含税金额',
      width: 120,
      dataIndex: 'amountInVat',
      ellipsis: true
    },
    {
      title: '未税金额',
      width: 120,
      dataIndex: 'amountExVat',
      ellipsis: true,
    },
    {
      title: '税金',
      dataIndex: 'tax',
      width: 120,
      ellipsis: true,
    },
    {
      title: '税率',
      dataIndex: 'taxRate',
      width: 120,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.RateToString(value);
      }
    },
  ];

  return (
    <>
      <WdiModal
        width={1000}
        title={props.title}
        visible={props.visible}
        onCancel={() => {
          if (!loading) {
            props.onClose?.()
          }
        }}
        cancelButtonProps={{
          hidden: true
        }}
        okButtonProps={{
          loading: loading
        }}
        okText={'创建'}
        onOk={() => {
          const values = form.getFieldsValue();
          const invoices: API.Invoice[] = [];
          dataSource.forEach(item => {
            invoices.push(Object.assign({
              supplierId: WdiSelectFormat.getvalue(values.supplierId),
              invoiceMakerCode: WdiSelectFormat.getvalue(values.invoiceMakerCode),
              invoiceSource: Enum.InvoiceSource.BAI_WANG,
            }, {...item}))
          })
          setLoading(true);
          Invoices.post({invoices: invoices}).then(response => {
            if (response.code != ResponseStatus.SUCCESS) {
              message.error(response.message);
            } else {
              message.success('创建成功');
              props.onSave?.(response);
            }
            setLoading(false);
          });
        }}
      >
        <Form form={form} layout={'vertical'}>
          <Row gutter={24}>
            <Col span={4}>
              <Form.Item name='invoiceMakerCode' label='开票方'>
                <WdiSelect {...{
                  placeholder: "请选择开票方",
                  showSearch: true,
                  labelInValue: true,
                  remote: true,
                  dataLoading: async (params) => {
                    const response = await InvoiceMaker.ajaxSearch(Object.assign({isActive: true}, params));
                    return response.data.map((item) => {
                      return {value: item.invoiceMakerCode, label: item.codeOrName};
                    });
                  }
                }} />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name='supplierId' label='供应商'>
                <WdiSelect {...{
                  placeholder: "请选择供应商",
                  showSearch: true,
                  labelInValue: true,
                  remote: true,
                  dataLoading: async (params) => {
                    const response = await Supplier.ajaxSearch(Object.assign({isActive: true}, params));
                    return response?.data?.map((item) => {
                      return {value: item.supplierId, label: item.codeOrName};
                    });
                  }
                }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <WdiTable
          columns={columns}
          showPageRows={10}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
        />

      </WdiModal>
    </>
  );
}

export const InvoiceCreateForApplyApp: React.FC<WdiModalAppProps> = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);

  const {data} = props;
  useEffect(() => {
    if (data?.invoiceMakerCode) {
      InvoiceMaker.get(data?.invoiceMakerCode).then(responseResult => {
        form?.setFieldsValue({
          invoiceMaker: responseResult.data.codeOrName
        })
      })
    }
    if (data?.supplierId) {
      Supplier.get(data?.supplierId).then(responseResult => {
        form?.setFieldsValue({
          supplier: responseResult.data.codeOrName
        })
      })
    }

    const invoiceDetails: any[] = [];
    data?.invoices.map((invoice: any) => {
      invoice?.details.map((detail: any) => {
        invoiceDetails.push(Object.assign({...invoice}, {...detail}));
      })
    })
    setDataSource(DataStore.init(invoiceDetails))

    // setDataSource(DataStore.init(data?.invoice?.details))
  }, [data])

  const columns: ColumnsType<any> = [
    {
      title: '发票号码',
      width: 150,
      dataIndex: 'invoiceNo',
      ellipsis: true,
    },
    {
      title: '发票代码',
      width: 150,
      dataIndex: 'invoiceCode',
      ellipsis: true,
    },
    {
      title: '货物/服务名称',
      dataIndex: 'commodityName',
      ellipsis: true,
    },
    {
      title: '含税金额',
      width: 120,
      dataIndex: 'amountInVat',
      ellipsis: true
    },
    {
      title: '未税金额',
      width: 120,
      dataIndex: 'amountExVat',
      ellipsis: true,
    },
    {
      title: '税金',
      dataIndex: 'tax',
      width: 120,
      ellipsis: true,
    },
    {
      title: '税率',
      dataIndex: 'taxRate',
      width: 120,
      ellipsis: true,
      render: (value: any, record: any) => {
        return wdiCore.Number.RateToString(value);
      }
    },
  ];

  const onSave = () => {
    setLoading(true);
    const invoices: API.Invoice[] = [];
    dataSource.forEach(item => {
      invoices.push(Object.assign({
        supplierId: data?.supplierId,
        invoiceMakerCode: data?.invoiceMakerCode,
        invoiceDate: data?.invoice?.invoiceDate,
        invoiceType: data?.invoice?.invoiceType,
        invoiceSource: Enum.InvoiceSource.BAI_WANG,
        realInvoiceCode: data?.invoice?.realInvoiceCode,
        realInvoiceNo: data?.invoice?.realInvoiceNo,
        purchaserTaxNo: data?.invoice?.purchaserTaxNo,
        salesName: data?.invoice?.salesName,
        salesTaxNo: data?.invoice?.salesTaxNo,
      }, {...item}))
    })

    Invoices.post({invoices: invoices}).then(response => {
      if (response.code != ResponseStatus.SUCCESS) {
        message.error(response.message);
      } else {
        message.success('创建成功');
        props.onSave?.(response);
      }
      setLoading(false);
    });
  }

  return (
    <>
      <WdiModal
        width={1000}
        title={props.title}
        visible={props.visible}
        onCancel={() => {
          if (!loading) {
            props.onClose?.()
          }
        }}
        cancelButtonProps={{
          hidden: true
        }}
        okButtonProps={{
          loading: loading
        }}
        okText={'创建'}
        onOk={() => {
          const vatType = data.vatType;
          if (!wdiCore.Object.IsNullOrUndefined(vatType.vatTypeValue)) {
            if (dataSource.findIndex(detail => detail.taxRate == vatType.vatTypeValue) < 0) {
              message.error('发票税率和核销单税率完全不一致，不能使用').then();
              return;
            }
            if (dataSource.findIndex(detail => detail.taxRate != vatType.vatTypeValue) > -1) {
              if (confirm('发票税率和核销单税率有不一致的，核销单只可使用相同税率的，确定继续创建吗？')) {
                onSave();
              }
            }
          }
          onSave();
        }}
      >
        <Form form={form} layout={'vertical'} labelCol={{span: 4}} wrapperCol={{span: 4}}>
          <Form.Item name='invoiceMaker' label='开票方'
                     hidden={data?.paymentMethodId != Enum.PaymentMethod.ACCOUNT_DEDUCT}>
            <WdiInput readOnly/>
          </Form.Item>
          <Form.Item name='supplier' label='供应商' hidden={data?.paymentMethodId != Enum.PaymentMethod.THIRD_PART}>
            <WdiInput readOnly/>
          </Form.Item>
        </Form>
        <WdiTable
          columns={columns}
          showPageRows={10}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
        />

      </WdiModal>
    </>
  );
}
